import { styled } from '@mui/material';

export type LabelProps = {
    uppercase?: boolean;
    fullWidth?: boolean;
};

export const Label = styled('span', {
    label: 'Label',
    shouldForwardProp: (propName) =>
        !['uppercase', 'fullWidth', 'sx'].includes(propName as string),
})<LabelProps>(({ theme, uppercase, fullWidth }) => ({
    fontSize: '11px',
    lineHeight: '16px',
    letterSpacing: 1,
    fontWeight: 'bold',
    fontFamily: 'AvertaStandard',
    color: theme.bino.color.label,
    textTransform: (uppercase ?? true) ? 'uppercase' : undefined,
    display: fullWidth ? 'block' : undefined,
    [theme.breakpoints.up('sm')]: {
        root: {
            fontSize: '12px',
            lineHeight: '16px',
        },
    },
}));

export default Label;
